var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-layout"}},[_c('div',{staticClass:"bg-sand"},[_c('div',{staticClass:"inner-container"},[_c('app-header-checkout')],1)]),_c('div',{staticClass:"bg-white py-4"},[_c('div',{staticClass:"inner-container-narrow pt-4 pb-8"},[(_vm.type)?_c(`checkout-${_vm.type}`,{tag:"component"}):_vm._e()],1)]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }